import { useState } from "react";

import { useMutation } from "@tanstack/react-query";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { form, initialValues, vendorValidations } from "./vendor-schema";
import { createVendor } from "services/data.internal.service";
import { useCustomerValue } from "providers/CustomerContext";

import VendorInfo from "./components/VendorInfo";
import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";

function AddVendor() {
  const { formRender } = form;
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const formInstance = useForm({
    defaultValues: { ...initialValues, customerCode },
    values: { ...initialValues, customerCode },
    resolver: yupResolver(vendorValidations),
  });
  const {
    register,
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
    reset,
  } = formInstance;

  const infoProps = {
    formRender,
    register,
    control,
    errors,
  };

  const createVendorMutation = useMutation(createVendor, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError: (data) => setAlert(<Error_ data={data} onChange={setAlert} />),
  });

  const onSubmit = (data) => {
    createVendorMutation.mutate({ ...data }, { onSuccess: () => reset() });
  };

  //   const handleSubmit = (values, actions) => {
  //     if (alert !== null) {
  //       setAlert(null);
  //     }
  //     createVendorMutation.mutate(
  //       {
  //         ...values,
  //       },
  //       {
  //         onSuccess: () => {
  //           actions.resetForm();
  //         },
  //       }
  //     );
  //     actions.setSubmitting(false);
  //   };

  return (
    <Layout>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        {alert}
        <VendorInfo {...infoProps} />
        <SubmitButton label="Submit" disabled={isSubmitting} url="/setup/vendor" />
      </form>
    </Layout>
  );
}

export default AddVendor;
